var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wl-container" }, [
    _c(
      "div",
      { class: _vm.tableStatus.editable ? "table-operator" : "" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "table",
            staticClass: "wl-table",
            attrs: { data: _vm.data, height: "100%", border: "", stripe: "" },
            on: { "selection-change": _vm.handleSelectionChange },
          },
          [
            _c("el-table-column", {
              attrs: { type: "selection", width: "50" },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "groupName",
                width: "180",
                label: _vm.$t("PAGE_PBCLIST_NAME"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "periodEndDate",
                width: "160",
                label: _vm.$t("TABLE_HEADER_periodEndDate"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("formatDate")(scope.row.periodEndDate)
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "detailedInfoReq",
                label: _vm.$t("TABLE_HEADER_detailedInfoReq"),
              },
            }),
            _c("el-table-column", {
              attrs: { width: "140", label: _vm.$t("TABLE_HEADER_DETAILS") },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.details(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("COMMON_VIEW")))]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm.tableStatus.editable
      ? _c(
          "div",
          { staticClass: "wl-btn-container" },
          [
            _c(
              "el-button",
              { staticClass: "cancel-btn", on: { click: _vm.onCancelBeh } },
              [_vm._v(_vm._s(_vm.$t("comment_reSet")) + "\n    ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "wl-green",
                attrs: { disabled: _vm.emptyChosen },
                on: { click: _vm.copy },
              },
              [_vm._v(_vm._s(_vm.$t("COMMON_COPY")) + "\n    ")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }